import * as React from "react";

const SvgIcnTasksSmall = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
            <path d="M0 0h24v24H0z" />
            <path
                d="M6 6h12a2 2 0 012 2v1a2 2 0 01-2 2H6a2 2 0 01-2-2V8a2 2 0 012-2zm.5 4a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM6 13h12a2 2 0 012 2v1a2 2 0 01-2 2H6a2 2 0 01-2-2v-1a2 2 0 012-2zm.5 4a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
                fill="currentColor"
                fillRule="nonzero"
            />
        </g>
    </svg>
);

export default SvgIcnTasksSmall;
